var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdejnyMapPathPraha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "360px",
    height: "178.5px",
    viewBox: "0 113 360 178.5",
    enableBackground: "new 0 113 360 178.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.472,226.522c2.485,0,4.5,2.015,4.5,4.5c0,2.483-2.015,4.5-4.5,4.5c-2.485,0-4.5-2.017-4.5-4.5 C146.972,228.537,148.986,226.522,151.472,226.522z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.367,115.919c-2.701,0-4.891,2.19-4.891,4.891c0,2.7,2.189,4.891,4.891,4.891s4.891-2.191,4.891-4.891 C353.258,118.109,351.068,115.919,348.367,115.919z M348.514,123.621c-1.374,0-2.962-1.441-2.962-2.812s1.444-2.82,2.815-2.82 c1.368,0,2.812,1.45,2.812,2.82C351.179,122.179,349.882,123.621,348.514,123.621z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    d: "M161.833,229.022 c1.633-0.192,3.235-0.616,4.827-1.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeDasharray: "9.6766,9.6766",
    d: " M174.946,222.84c16.103-12.381,34.61-39.826,75.221-53.007c29.023-9.42,68.742-31.868,85.887-41.948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    d: "M340.224,125.416 c2.738-1.636,4.276-2.582,4.276-2.582"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdejnyMapPathPraha);
export default __webpack_public_path__ + "static/media/prodejny_map_path_praha.902bd5eb78cf1ecfb9398a201373f97d.svg";
export { ForwardRef as ReactComponent };